@if (currentProject) {
  <ngx-simplebar class="mx-n3 pt-4 px-4 file-manager-content-scroll">
    <div class="row">
      <div class="col-lg-12">
        <div class="card mt-n4 mx-n4">
          <div class="bg-info-subtle">
            <div class="card-body pb-0 px-4">
              <div class="row mb-3">
                <div class="col-md">
                  <div class="row align-items-center g-3">
                    <div class="col-md-auto d-lg-none">
                      <button type="button" class="btn btn-sm" id="sideabr-hamburger-icon" (click)="toggleSidebar(true)">
                        <span class="hamburger-icon">
                          <span></span>
                          <span></span>
                          <span></span>
                        </span>
                      </button>
                    </div>
                    @if (currentProject.logo) {
                      <div class="col-md-auto">
                        <div class="avatar-md">
                          <div class="avatar-title bg-white rounded-circle">
                            <img src="{{ currentProject.logo }}" alt="" class="avatar-xs">
                          </div>
                        </div>
                      </div>
                    }
                    <div class="col-md">
                      <div>
                        <h4 class="fw-bold">{{ currentProject.name }}</h4>
                        <div class="hstack gap-3 flex-wrap">
                          <div><span class="fw-bold text-decoration-underline">Create Date</span>: <span class="fw-medium">{{ currentProject.createdAt | date: 'medium' }}</span></div>
                          @if (currentProject.updatedAt !== currentProject.createdAt) {
                            <div class="vr"></div>
                          }
                          @if (currentProject.updatedAt !== currentProject.createdAt) {
                            <div><span class="fw-bold text-decoration-underline">Last Update</span>: <span class="fw-medium">{{ currentProject.updatedAt | date: 'medium' }}</span></div>
                          }
                          <div class="vr"></div>
                          <div class="badge rounded-pill fs-8" [ngClass]="currentProject.active ? 'bg-success' : 'bg-danger'">{{ currentProject.active ? 'Active' : 'Not Active' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                @if (isOwner && currentProject.parent_project_id) {
                  <div class="col-md-auto">
                    <div class="hstack gap-1 flex-wrap">
                      <button type="button" class="btn py-0 fs-18 text-danger-emphasis favourite-btn active shadow-none" (click)="openDeleteProjectModal()">
                        <i class="ri-delete-bin-line" [ngbTooltip]="'Delete Project'"></i>
                      </button>
                    </div>
                  </div>
                }
              </div>
              <ul ngbNav #customNav="ngbNav" [activeId]="currenttab" class="nav nav-tabs-custom border-bottom-0" role="tablist">
                <li [ngbNavItem]="1" class="nav-item">
                  <a ngbNavLink role="none" (click)="changeTab('overview')"> Description
                    <i class="ri-information-fill align-bottom" [ngbTooltip]="'Project description'" placement="bottom"></i>
                  </a>
                  <ng-template ngbNavContent>
                    @if (currentProject.description) {
                      <div class="row mt-n3">
                        @if (isOwner) {
                          <div class="col">
                            @if (currentProject.description) {
                              <quill-editor classes="border-0" [(ngModel)]="currentProject.description" [readOnly]="true" [modules]="{toolbar:false}"></quill-editor>
                            }
                          </div>
                        }
                        @if (isOwner && current_client.plan !== null) {
                          <div class="col-auto">
                            <div class="hstack gap-1 flex-wrap">
                              <button type="button" class="btn py-0 fs-18 text-success-emphasis favourite-btn active shadow-none" (click)="openDescriptionModal(true)">
                                <i class="ri-edit-2-line" [ngbTooltip]="'Edit Description'"></i>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (!currentProject.description) {
                      <div class="container">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="text-center mt-sm-5 pt-4">
                              <div class="mb-5 text-white-50">
                                <p class="fs-14">There is no description for this project.</p>
                                @if (isOwner && current_client.plan !== null) {
                                  <div class="mt-4 pt-2">
                                    <a class="btn btn-success" (click)="openDescriptionModal()">
                                      <i class="ri-add-line align-bottom me-1"></i>Add Description</a>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="7" class="nav-item">
                    <a ngbNavLink role="none" (click)="changeTab('assessments')"> Subject Files
                      <i class="ri-information-fill align-bottom" [ngbTooltip]="'List or assessment files that are in the specific project'" placement="bottom"></i>
                    </a>
                    <ng-template ngbNavContent>
                      <app-project-assessment [currentProject]="currentProject"></app-project-assessment>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2" class="nav-item">
                    <a ngbNavLink role="none" (click)="changeTab('conversations')"> Conversations
                      <i class="ri-information-fill align-bottom" [ngbTooltip]="'List or conversations that are in the specific project'" placement="bottom"></i>
                    </a>
                    <ng-template ngbNavContent>
                      <app-project-conversation [currentProject]="currentProject"></app-project-conversation>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="3" class="nav-item">
                    <a ngbNavLink role="none" (click)="changeTab('questionnaires')"> Questionnaires
                      <i class="ri-information-fill align-bottom" [ngbTooltip]="'List or questionnaires that are in the specific project'" placement="bottom"></i>
                    </a>
                    <ng-template ngbNavContent>
                      <app-project-questionnaire [currentProject]="currentProject"></app-project-questionnaire>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="5" class="nav-item">
                    <a ngbNavLink role="none" (click)="changeTab('examinees')"> Examines
                      <i class="ri-information-fill align-bottom" [ngbTooltip]="'List of candidates that were invited to take questionnaire or to an open conversation under the specified project'" placement="bottom"></i>
                    </a>
                    <ng-template ngbNavContent>
                      <app-project-examinee [currentProject]="currentProject"></app-project-examinee>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="6" class="nav-item">
                    <a ngbNavLink role="none" (click)="changeTab('team')"> Project Team
                      <i class="ri-information-fill align-bottom" [ngbTooltip]="'list of users that carry a role and was added to the project by the project owner'" placement="bottom"></i>
                    </a>
                    <ng-template ngbNavContent>
                      <app-project-team [currentProject]="currentProject"></app-project-team>
                    </ng-template>
                  </li>
                </ul>
              </div>
              <!-- end card body -->
            </div>
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="tab-content text-muted">
            <div [ngbNavOutlet]="customNav"></div>
          </div>
        </div>
      </div>
    </ngx-simplebar>
  }

  <ng-template #descriptionModal let-modal>
    <div class="modal-content">
      <div class="modal-header p-3">
        <h4 class="card-title mb-0">{{ editMode ? 'Edit Project Description' : 'Add Project Description' }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="email" class="form-label">Description</label>
          <quill-editor [styles]="{height: '250px'}" [(ngModel)]="description" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>
        </div>
        <div class="d-flex gap-2 justify-content-between mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <div class="d-flex gap-2">
            <button type="button" class="btn w-sm btn-danger" data-bs-dismiss="modal" (click)="openRemoveDescriptionModal()">Remove Description</button>
            <button type="button" class="btn w-sm btn-success btn-load" (click)="saveDescription()">
              <span class="d-flex justify-content-center">
                @if (submitted && spinner) {
                  <span class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                }
                <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Save</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #removeDescriptionModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to remove the description of </h4>
            <h4><span class="fw-semibold text-warning">{{ currentProject.name }}</span>?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="saveDescription(true)">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteProjectModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to delete</h4>
            <h4><span class="fw-semibold text-warning">{{ currentProject.name }}</span>?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteProject()">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
          @if (!success) {
            <p class="text-muted mx-4 mb-0">{{ message }}</p>
          }
        </div>
      </div>
    </div>
  </ng-template>